/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_RefreshInputs */

const cs_property_registry_refresh = /** @type {(inputs: Property_Registry_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obnovit KN`)
};

const en_property_registry_refresh = /** @type {(inputs: Property_Registry_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh KN`)
};

/**
* | output |
* | --- |
* | "Refresh KN" |
*
* @param {Property_Registry_RefreshInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_refresh = /** @type {((inputs?: Property_Registry_RefreshInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_RefreshInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_refresh(inputs)
	return cs_property_registry_refresh(inputs)
});